import React, { useState } from "react";
import { LoginForm } from "../../components";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { handleApi } from "../../utils/authentication";
import { SIGNIN_USER } from "../../redux/features/user/userSlice";
import { getSubscriptionLockedFallbackPath } from "../../utils/subscriptionAccess";
import { getClientLandingPath } from "../../utils/clientRouting";
import {
  UPDATE_IS_SYNCING,
  SET_JOB_COUNT,
  SET_REMAINING_JOB_COUNT,
  RESET_SYNC_PROGRESS,
} from "../../redux/features/user/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const ClientLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user);

  const handleClientLogin = async () => {
    try {
      setIsLoading(true);
      let method = "POST";
      let headers = {
        "Content-Type": "application/json",
      };
      let data = JSON.stringify(formik?.values);
      let result = await handleApi("user_login", method, headers, data);

      if (result?.success) {
        let {
          is_blocked,
          role_id,
          role_name,
          status = 0,
          is_syncing,
          job_count,
          remaining_job_count,
          subscription_access,
          ...filtered_data
        } = result?.data?.user_info;
        //console.log(result?.data?.user_info)

        if (!is_blocked && status) {
          dispatch(
            SIGNIN_USER({
              ...filtered_data,
              ...(subscription_access ?? {}),
              isLoggedIn: true,
              is_client: true,
              status,
              role_id,
              role_name,
              integration: { value: "social_media", label: "Social Media" },
            }),
          );
          dispatch(UPDATE_IS_SYNCING(!!is_syncing));
          if (
            typeof job_count !== "undefined" &&
            typeof remaining_job_count !== "undefined"
          ) {
            dispatch(SET_JOB_COUNT(Number(job_count)));
            dispatch(SET_REMAINING_JOB_COUNT(Number(remaining_job_count)));
          } else {
            dispatch(RESET_SYNC_PROGRESS());
          }
        } else {
          dispatch(
            SIGNIN_USER({
              ...filtered_data,
              ...(subscription_access ?? {}),
              isLoggedIn: true,
              is_client: true,
            }),
          );
          dispatch(UPDATE_IS_SYNCING(!!is_syncing));
          if (
            typeof job_count !== "undefined" &&
            typeof remaining_job_count !== "undefined"
          ) {
            dispatch(SET_JOB_COUNT(Number(job_count)));
            dispatch(SET_REMAINING_JOB_COUNT(Number(remaining_job_count)));
          } else {
            dispatch(RESET_SYNC_PROGRESS());
          }
        }

        if (subscription_access?.can_access === false) {
          navigate(
            getSubscriptionLockedFallbackPath({
              role_id,
              client_id: filtered_data?.client_id,
            }),
          );
        } else {
          navigate(getClientLandingPath({ ...filtered_data, role_id }));
        }
      } else {
        setError(result?.error?.error_message);
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Failed to authenticate user",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
      }
      setIsLoading(false);
    } catch (e) {
      console.log(e);
      setError(e.message);
      toast.error(e.message ? e.message : "Failed to authenticate user", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  //formik validtion
  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is Required"),
    password: Yup.string().required("Password is Required"),
  });

  const formik = useFormik({
    initialValues: {
      email: location?.state?.email ? location?.state?.email : "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleClientLogin();
    },
  });

  if (user?.isLoggedIn && user?.is_client) {
    return <Navigate to={getClientLandingPath(user)} replace />;
  }

  return (
    <LoginForm
      formik={formik}
      isLoading={isLoading}
      error={error}
      forget_password_link="/client/forget_password"
    />
  );
};

export default ClientLogin;
